import { render, staticRenderFns } from "./equipment-section.vue?vue&type=template&id=f872ecce"
import script from "./equipment-section.vue?vue&type=script&lang=js"
export * from "./equipment-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports